import {
  EnvironmentProviders,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { TelehealthConfigService } from './telehealth/telehealth-config.service';

export function provideTelehealthConfig(): EnvironmentProviders {
  return provideAppInitializer(() => inject(TelehealthConfigService).load());
}
